import { BaseSelect } from '@app/components';
import { promotionApi } from '@app/store';
import { createColumnHelper } from '@tanstack/react-table';
import { IPromotion } from '@app/common';
import React from 'react';
import { ResourceSelect, ResourceSelectProps } from '../ResourceSelect';

const columnHelper = createColumnHelper<IPromotion>();

const columns = [
  // @ts-ignore
  columnHelper.accessor('name', {
    header: () => (
      <BaseSelect.ListHeaderItem width="100%">
        Nom
      </BaseSelect.ListHeaderItem>
    ),
    cell: (info) => (
      <BaseSelect.ListItemCol width="100%">
        <BaseSelect.ListItemText numberOfLines={1} bold>
          {info.getValue()}
        </BaseSelect.ListItemText>
      </BaseSelect.ListItemCol>
    ),
  }),
];

export const PromotionSelect = ({ label = 'Promotions', ...props }: Omit<ResourceSelectProps<IPromotion>, 'columns' | 'useQuery'>) => {
  return (
    <ResourceSelect
      label={label}
      columns={columns}
      useQuery={promotionApi.useReadManyPromotionsQuery}
      {...props}
    />
  );
};
